import axios from "axios";
import { showErrorToast, showSuccessToast } from "./toaster";
import { baseurl } from "../config/url";
import logo from "../Images/buillogo6.png";

// Initiate Razorpay payment
export const displayRazorpay = async (amount, functioncall) => {
  try {
    // Request order creation from the backend
    const response = await axios.post(
      `${baseurl}/api/payment/create-payment-order`,
      { amount: amount }
    );

    if (!response.data.success) {
      showErrorToast(response.data.message || "Failed to create order");
      return;
    }

    const { order, key } = response.data;
    const { id: order_id, currency } = order;

    const options = {
      key, // Use the Razorpay Key ID from the backend response
      amount: amount, // Convert to the smallest currency unit (paise)
      currency,
      name: "BuildPro", // Add your company name
      description: "Add Product Payment",
      image: logo,
      order_id,
      handler: async function (response) {
        const { razorpay_payment_id, razorpay_order_id, razorpay_signature } =
          response;
        const data = {
          orderCreationId: order_id,
          razorpayPaymentId: razorpay_payment_id,
          razorpayOrderId: razorpay_order_id,
          razorpaySignature: razorpay_signature,
        };
        if (data.razorpayPaymentId) functioncall(data);
        console.log("Payment Details:", data);
        showSuccessToast("Payment Successful!");
      },
      notes: {
        address: "Customer Address",
      },
      theme: {
        color: "#F37254",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  } catch (error) {
    console.error("Error in Razorpay payment:", error);
    showErrorToast("Payment failed. Please try again later.");
  } 
};
